module.exports = __webpack_public_path__ + "static/auto-man-b71c1d3cae76da82be8f484dbcf16df5.jpg";